<template>
  <button
    class="w-full h-12 px-4 font-semibold rounded-md focus:outline-none"
    :class="{
      'text-white bg-blue-600 border-2 border-blue-600':
        buttonType === 'primary',
      'border-2 border-blue-600 dark:text-white': buttonType === 'outline',
      'border-2 border-red-600 dark:text-white':
        buttonType === 'outline-danger',
    }"
    @click="$emit('click')"
  >
    <slot />
  </button>
</template>

<script>
export default {
  props: ["type"],
  computed: {
    buttonType() {
      if (this.type) {
        return this.type;
      } else {
        return "primary";
      }
    },
  },
};
</script>
